import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'ca-search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit {
    @ViewChild('searchInput') searchInput: ElementRef;
    @Input() searchTerm: string = '';
    @Input() placeholder: string = '';
    @Input() autoFocusSearchField: boolean = false;
    @Input() debounceTimeInMs: number = 600;
    @Input() isSearchLoading: boolean = false;

    /**
     * Emits each new search result string (debounced by 200ms)
     */
    @Output() onSearchTermChange: EventEmitter<string> = new EventEmitter();

    private searchTerm$$ = new Subject<string>();

    get _placeholder(): string {
        return this.placeholder || this.translateService.instant('GENERAL.SEARCH');
    }

    constructor(private translateService: TranslateService) {}

    /**
     *To manage request race conditions when inputting in a search bar we are setting the debounce time to 1s,
      ensuring that only the latest request is processed - issue occurs due to delayed processing from RDP side
     */
    ngOnInit(): void {
        this.searchTerm$$
            .asObservable()
            .pipe(debounceTime(this.debounceTimeInMs), distinctUntilChanged(), untilDestroyed(this))
            .subscribe(
                (term: string) => this.onSearchTermChange.emit(term),
                (err: unknown) => console.error('Error emitting search result', err),
            );
    }

    onDeleteClick(): void {
        this.searchInput.nativeElement.focus();
        this.searchTerm = '';
        this._onSearchTermChange();
    }

    _onSearchTermChange(): void {
        this.searchTerm$$.next(this.searchTerm);
    }
}
